import styled from '@emotion/styled';

export const FDTMPageContainer = styled.div`
  display: flex;

  @media (max-width: 1199px) {
    position: absolute;
    top: 0;
  }
`;

export const FDTMContainer = styled.div`
  position: fixed;
  width: 100vw;
  height: 100%;

  @media (min-width: 1200px) {
    width: calc(100vw - 300px);
  }

  @media (min-width: 1536px) {
    width: calc(100vw - 300px);
  }
  & > div:first-child {
    width: 100% !important;
  }
  @media (max-width: 1199px) {
    margin-top: 120px;
    height: calc(-120px + 100vh);
  }
`;
